import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Col, FormGroup, Input, Label, FormText, Collapse, Modal, Spinner, ModalBody, ModalFooter,
} from "reactstrap";
import { NavLink as NavLinkRRD, Link, useHistory } from "react-router-dom";
import iconSet from "selection.json";
import IcomoonReact, { iconList } from "icomoon-react";
import { Form, Field } from "react-final-form";
import dataProvider from 'dataProvider';
import auth from "authProvider";
import ModalImage from "react-modal-image";
import decodeJwt from 'jwt-decode';
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

export const ExportToExcel = ({ apiData, fileName }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = (apiData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(apiData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <Button onClick={(e) => exportToCSV(apiData, fileName)} style={{ padding: 6, boxShadow: 0, borderWidth: 1, borderColor: '#ccc' }}><IcomoonReact iconSet={iconSet} color="#556F71" size={20} icon="share" /></Button>
  );
};

const Banner = (props) => {
  const history = useHistory();
  const [banners, setBanners] = useState();
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editloading, setEditloading] = useState(false);
  const [flag, setFlag] = useState(false);
  const [collapse, setCollapse] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [data, setData] = useState(false);
  const [page, setPage] = useState(1);
  const [more, setMore] = useState(true);
  const [reload, setReload] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState({ visible: false, id: null, index: null });
  const [sucess, setSucess] = useState(false);
  const [editsucess, setEditsucess] = useState(false);
  const [peropen, setPeropen] = useState(false)
  const [exported, setExported] = useState([]);
  const [images, setImages] = React.useState(null)

  const fileHandler = (e) => {
    setImages(e.target.files[0])
  }


  const onLogout = () => {
    auth.logout();
    history.push("/")
  }

  const onSubmit = (values, reset) => {
    setLoading(true)
    dataProvider.createBanner('banners', { ...values })
      .then(({ data }) => {
        setLoading(false)
        setSucess(true)
        setTimeout(() => Pushcreate(), 2000);
      })
    setData(data)
    history.push("/banner");
  };
  const Pushcreate = () => {
    setSucess(false)
    window.location.reload();
  }
  const Pushedit = () => {
    setEditsucess(false)
    window.location.reload();

  }
  useEffect(() => {
    let token = localStorage.getItem('token');
    dataProvider.getList('banners', { params: { pagination: { page: page, perPage: 20 }, sort: { order: 'desc', field: 'id' }, filter: {}, token: token } })
      .then(({ data }) => {
        if (data && data.length > 0) {
          var obj = data.map(item => ({ id: item.id, Bannerlink: item.banner_link }));
          setExported(obj);
        }
        if (data.length < 20) {
          setMore(false)
        }
        else {
          setMore(true)
        }
        setBanners(data);
      })
      .catch(error => {
        if (error?.response?.data?.message === 'Invalid Token') {
          setModalOpen(true)
        }
      });
  }, [props, reload]);

  const removeData = (id, index) => {
    dataProvider.delete('banners', { id: id });
    let bannerArr = banners;
    bannerArr.splice(index, 1);
    setBanners(bannerArr);
    setFlag(!flag)
    setConfirmOpen({ visible: false, id: null, index: null });
  }
  const onSubmit_update = (values, id) => {
    setOpen(false);
    setEditloading(true)

    dataProvider.updateBanner('banners', { banner: values.banner, heading: values.heading ? values.heading : '', sub_heading: values.sub_heading ? values.sub_heading : '', id: banners[pos].id, banner_link: values.banner_link ? values.banner_link : '' })
      .then(({ data }) => {
        setEditloading(false)
        setEditsucess(true)
        setTimeout(() => Pushedit(), 2000);
      })
      .catch(error => {
        setEditloading(false)
        if (error?.response?.data?.message === 'Invalid Token') {
          setModalOpen(true)
        }
      });
  };
  const handleClickOpen = (index) => {
    setPos(index)
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const Closeconfirm = () => {
    setConfirmOpen({ visible: false, id: null, index: null });
  };

  const onPagination = (i) => {
    let newPage = page + i;
    if (newPage == 0) {
      return;
    }
    else if (i === 1 && !more) {
      return;
    }
    setPage(newPage);
    setReload(!reload);
  }
  let per = localStorage.getItem('permission');
  // let token = localStorage.getItem('token');
  // const decodedToken = decodeJwt(token);
  // const per = decodedToken.user.permissions;

  const perModal = () => {
    setPeropen(true)
  }
  const permodalClose = () => {
    setPeropen(false)
  }
  const handleEditclose = () => {
    setOpen(false)
    setImages(null)

  }
  if (!banners) {
    return (
      <>
        <div >
          <td style={{ color: '#12ACF6', position: "fixed", top: "50%", left: "55%", transform: "translate(-50%, -50%)" }} colSpan={11}><Spinner /></td>
        </div>
      </>
    )
  }

  return (
    <>
      <div className="header pb-8 pt-5 pt-md-6" style={{
        width: '100%',
        backgroundImage:
          "url(" +
          require("../../../assets/img/brand/header.jpg").default +
          ")",
      }}>
        <Container fluid >
          <div className="header-body">
            {/* header*/}
            <h1 className="mb-0" style={{ color: 'white' }}>BANNER</h1>
          </div>
        </Container>
      </div>
      <Container className="mt--7" fluid>
        <Row className="mt-4">
          <Col className="mb-5 mb-xl-0" xl="7">
            <Card className="shadow" style={{ borderRadius: 10 }}>
              <CardHeader className="border-0" style={{ display: 'flex', color: 'white', fontSize: '1.25rem', paddingLeft: '20px', flexDirection: 'row', justifyContent: 'space-between' }} >
                <div style={{ alignContent: 'flex-start', fontWeight: 'bold' }}><h3>BANNERS</h3></div>
                <div style={{ alignContent: 'flex-end' }}>
                  {page > 1 || page !== 1 ? <Button onClick={() => onPagination(-1)} style={{ backgroundColor: 'white', fontSize: '0.75rem', height: '2.5rem', padding: '0px', color: 'rgb(66 54 47)', width: '5rem', margin: '0px', borderColor: 'rgb(144 151 153)' }} >
                    <IcomoonReact style={{ paddingRight: 5 }} iconSet={iconSet} color="#77665c" size={11} icon="prev" />PREV</Button>
                    : <Button disabled style={{ backgroundColor: 'white', fontSize: '0.7rem', height: '2.5rem', padding: '0px', color: '#77665c', width: '5rem', margin: '0px', borderColor: '#ccc' }} >
                      <IcomoonReact style={{ paddingRight: 5 }} iconSet={iconSet} color="#77665c" size={10} icon="prev" />PREV</Button>}
                  {more ? <Button onClick={() => onPagination(1)} style={{ backgroundColor: 'white', fontSize: '0.7rem', borderColor: '#ccc', padding: '0px', height: '2.5rem', color: 'rgb(66 54 47)', width: '5rem', borderColor: 'rgb(144 151 153)' }} > NEXT
                    <IcomoonReact style={{ paddingLeft: 5 }} iconSet={iconSet} color="#77665c" size={11} icon="next" /></Button> :
                    <Button disabled style={{ backgroundColor: 'white', fontSize: '0.7rem', borderColor: '#ccc', padding: '0px', height: '2.5rem', color: '#77665c', width: '5rem', borderColor: '#ccc' }} > NEXT
                      <IcomoonReact style={{ paddingLeft: 5 }} iconSet={iconSet} color="#77665c" size={10} icon="next" /></Button>}
                  <ExportToExcel apiData={exported} fileName="Banners" />
                </div>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col" style={{ width: 10 }}></th>
                    <th scope="col">BANNER</th>
                    <th scope="col" style={{ marginLeft: 20 }}>IMAGE</th>
                    <th scope="col" style={{ width: 100 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {banners && banners.length > 0 && (
                    banners.map((item, index) => (
                      <tr >
                        <td>
                          <Button className={collapse === index ? "button_collapse_close" : "button_collapse_open"} onClick={() => setCollapse(collapse === index ? false : index)}></Button>
                        </td>
                        <td style={{ color: '#12ACF6', width: 100 }}>
                          <div style={{ textTransform: 'capitalize' }}>{item.heading}</div>
                          <Collapse isOpen={collapse === index ? true : false}>
                            <div style={{ color: '#12ACF6', marginTop: 10, fontSize: '10px', textTransform: 'capitalize' }}>{item.sub_heading}</div>
                          </Collapse>
                        </td>
                        <td style={{ width: '0.5rem', paddingLeft: 10 }}>
                          <ModalImage
                            className='image-size'
                            small={item.banner_path}
                            large={item.banner_path}
                            hideDownload={true}
                            hideZoom={true}
                          />
                        </td>
                        {/* <td style={{ paddingLeft:10,width:5}}><img style={{borderRadius:10,margin:0,width:80 }} src={item.banner_path} className="img-fluid" alt="..." /></td> */}
                        <td>
                          {per.includes('banner_edit') ? <Button style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }} onClick={() => handleClickOpen(index)} ><IcomoonReact iconSet={iconSet} color="#ccc" size={15} icon="edit" /></Button> :
                            <Button onClick={() => perModal()} style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }} ><IcomoonReact iconSet={iconSet} color="#ccc" size={15} icon="edit" /></Button>}
                          {per.includes('banner_delete') ? <Button style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }} onClick={() => setConfirmOpen({ visible: true, id: item.id, index: index })}>
                            <IcomoonReact iconSet={iconSet} color="#ccc" size={15} icon="delete" /></Button> :
                            <Button onClick={() => perModal()} style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }} >
                              <IcomoonReact iconSet={iconSet} color="#ccc" size={15} icon="delete" /></Button>}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
              <Modal isOpen={confirmOpen.visible} size="sm">
                <div className="modal-header"></div>
                <ModalBody style={{ color: 'red', padding: 0, paddingLeft: 20 }}>DO YOU WANT DELETE THIS  ?</ModalBody>
                <ModalFooter >
                  <Button onClick={Closeconfirm} style={{ color: 'white', backgroundColor: 'rgb(5 160 187)', border: 0 }} type="button">
                    NO
                  </Button>
                  <Button onClick={() => removeData(confirmOpen.id, confirmOpen.index)} style={{ color: 'white', backgroundColor: 'rgb(5 160 187)', border: 0 }} type="button">
                    YES
                  </Button>
                </ModalFooter>
              </Modal>
            </Card>
          </Col>
          <Col xl="5">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <div className="col">
                    <h3 className="mb-0" style={{ color: '#5d5d49', fontWeight: 'bold', marginLeft: 14 }}>CREATE BANNER</h3>
                  </div>
                </Row>
              </CardHeader>
              <Form
                onSubmit={onSubmit}
                validate={values => {
                  const errors = {};
                  if (!values.banner) {
                    errors.banner = "Required";
                  }
                  return errors;
                }}
                render={({ handleSubmit, reset, form }) => (
                  <form onSubmit={handleSubmit} style={{ paddingTop: '0px', paddingLeft: 20, paddingRight: 30 }}>
                    <div className="pl-lg-4">
                      <Row>
                        <Col lg="12">
                          <FormGroup>
                            <Label style={{ fontSize: ' 0.9rem', color: '#5d5d49' }} for="heading">Banner Heading</Label>
                            <Field name="heading" >
                              {({ input, meta }) => (
                                <div>
                                  <Input
                                    {...input}
                                    style={{ color: 'black', borderRadius: 10 }}
                                    type="text"
                                    name="heading"
                                    placeholder="Enter Banner Tittle"
                                  />
                                </div>
                              )}
                            </Field>
                          </FormGroup>
                        </Col>
                        <Col lg="12">
                          <FormGroup>
                            <Label style={{ fontSize: ' 0.9rem', color: '#5d5d49' }} for="sub_heading">Sub Heading</Label>
                            <Field name="sub_heading"  >
                              {({ input, meta }) => (
                                <div>
                                  <Input
                                    {...input}
                                    style={{ color: 'black', borderRadius: 10 }}
                                    type="text"
                                    name="sub_heading"
                                    placeholder="Enter Subheading"
                                  />
                                </div>
                              )}
                            </Field>
                          </FormGroup>
                        </Col>
                        <Col lg="12">
                          <Label style={{ fontSize: ' 0.9rem', color: '#5d5d49' }}>Background Image</Label>
                          <Field name="banner" >
                            {({ input: { value, onChange, ...input }, meta }) => (
                              <div style={{
                                border: 'solid',
                                borderWidth: 'thin',
                                borderRadius: '10px',
                                padding: '8px', borderColor: '#ccc'
                              }} >
                                <Input
                                  {...input}
                                  name="banner"
                                  style={{ color: 'black' }}
                                  type="file"
                                  accept=".jpg,.jpeg,.png"
                                  onChange={(e) => onChange(e.target.files)}
                                />
                                {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                              </div>
                            )}
                          </Field>
                        </Col>
                        <Col lg="12" style={{ marginTop: 10 }}>
                          <FormGroup>
                            <Label style={{ fontSize: ' 0.9rem', color: '#5d5d49' }} for="heading">Banner Link</Label>
                            <Field name="banner_link" >
                              {({ input, meta }) => (
                                <div>
                                  <Input
                                    {...input}
                                    style={{ color: 'black', borderRadius: 10 }}
                                    type="text"
                                    name="heading"
                                    placeholder="Enter Banner Link"
                                  />
                                </div>
                              )}
                            </Field>
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                    {per.includes('banner_add') ?
                      <Row>
                        <Col lg="12" style={{ marginTop: 20 }}>
                          <div style={{ marginLeft: 20, paddingLeft: 10, paddingRight: 2 }}>
                            <Button disabled={loading} type="submit" style={{ backgroundColor: 'rgb(4 64 87)', color: 'white', width: '100%', border: 0, padding: 15, marginBottom: 25, fontWeight: 'bold', borderRadius: 10 }}>
                              {loading && (<Spinner as="span" size="sm" role="status" aria-hidden="true" style={{ marginRight: 20 }} />)}SUBMIT</Button>{' '}
                          </div>
                        </Col>
                      </Row>
                      :
                      <Col lg="12">
                        <div style={{ padding: 20 }}>
                          <Button onClick={() => perModal()} style={{ backgroundColor: 'rgb(4 64 87)', color: 'white', width: '100%' }}>
                            SUBMIT</Button>{' '}
                        </div>
                      </Col>}
                  </form>
                )}
              />
            </Card>
          </Col>
        </Row>
      </Container>
      <div style={{ width: '600px' }}>
        <Modal
          className="modal-dialog-centered"
          isOpen={open}
        >
          <div onClick={handleEditclose} style={{ backgroundColor: 'rgb(193 193 125)', width: '30px', height: '30px', position: 'absolute', right: '-10px', top: '-10px', borderRadius: '50%' }}>
            <IcomoonReact iconSet={iconSet} onClick={handleEditclose} style={{ position: 'absolute', right: 10, top: 10 }} color="white" size={12} icon="close" />
          </div>
          <div style={{ textAlign: 'center', backgroundColor: 'rgb(4 64 87)', padding: 10 }} >
            <h4 style={{ color: "white", marginTop: '20px', marginLeft: 25 }}>
              EDIT BANNER
            </h4>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => setOpen(false)}
            >
            </button>
          </div>
          <div>
            <Form
              onSubmit={onSubmit_update}
              render={({ handleSubmit, values, submitting, validating, valid }) => (
                <form onSubmit={handleSubmit} style={{ padding: '20px' }}>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="12">
                        <FormGroup>
                          <Label style={{ fontSize: ' 0.8125rem' }} for="heading">Banner Heading</Label>
                          <Field name="heading" initialValue={banners[pos].heading ? banners[pos].heading : ''}>
                            {({ input, meta }) => (
                              <div>
                                <Input
                                  {...input}
                                  style={{ color: 'black' }}
                                  type="text"
                                  name="heading"
                                  placeholder="Enter Banner Tittle"
                                />
                              </div>
                            )}
                          </Field>
                        </FormGroup>
                      </Col>
                      <Col lg="12">
                        <FormGroup>
                          <Label style={{ fontSize: ' 0.8125rem' }} for="sub_heading">Sub Heading</Label>
                          <Field name="sub_heading" initialValue={banners[pos].sub_heading ? banners[pos].sub_heading : ''}>
                            {({ input, meta }) => (
                              <div>
                                <Input
                                  {...input}
                                  style={{ color: 'black' }}
                                  type="text"
                                  name="sub_heading"
                                  placeholder="Enter Subheading"
                                />
                              </div>
                            )}
                          </Field>
                        </FormGroup>
                      </Col>
                      {banners[pos].banner_path && (
                        <Col lg="12">
                          <ModalImage
                            className='image-editsize'
                            small={images ? URL.createObjectURL(images) : banners[pos].banner_path}
                            large={images ? URL.createObjectURL(images) : banners[pos].banner_path}
                            hideDownload={true}
                            hideZoom={true}
                          />
                        </Col>
                      )}
                      <Col lg="12" style={{ marginTop: 5 }}>
                        <Label style={{ fontSize: ' 0.9rem', color: '#5d5d49' }}>Background Image</Label>
                        <Field name="banner" >
                          {({ input: { value, onChange, ...input }, meta }) => (
                            <div style={{
                              border: 'solid',
                              borderWidth: 'thin',
                              borderRadius: '10px',
                              padding: '8px',
                              borderColor: '#ccc',
                              // backgroundSize:'contain',
                            }} >
                              {/* <img src={file ? URL.createObjectURL(file) : null} alt={file ? file.name : null} /> */}
                              <input
                                type="file"
                                {...input}
                                style={{ color: 'black' }}
                                onInput={fileHandler}
                                accept=".jpg,.jpeg,.png"
                                onChange={(e) => onChange(e.target.files)}
                              />
                              {/* <Input
                                {...input}
                                name="banner"
                                style={{ color: 'black' }}
                                type="file"
                                accept=".jpg,.jpeg,.png"
                                onChange={(e) => onChange(e.target.files)}
                              /> */}
                              {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                            </div>
                          )}
                        </Field>
                      </Col>
                      <Col lg="12" style={{ marginTop: 10 }}>
                        <FormGroup>
                          <Label style={{ fontSize: ' 0.9rem', color: '#5d5d49' }} for="heading">Banner Link</Label>
                          <Field name="banner_link" initialValue={banners[pos].banner_link ? banners[pos].banner_link : ''} >
                            {({ input, meta }) => (
                              <div>
                                <Input
                                  {...input}
                                  style={{ color: 'black', borderRadius: 10 }}
                                  type="text"
                                  name="heading"
                                  placeholder="Enter Banner Link"
                                />
                              </div>
                            )}
                          </Field>
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                  <div style={{ marginTop: 30, display: 'flex', justifyContent: 'center' }}>
                    <Button disabled={editloading} onClick={handleClose} color={'white'} type="submit" style={{ backgroundColor: 'rgb(4 64 87)', border: 0, marginLeft: '40px', color: 'white', width: '50%', borderRadius: '10px', marginBottom: 10 }} >
                      {editloading && (<Spinner as="span" size="sm" role="status" aria-hidden="true" style={{ marginRight: 20 }} />)}
                      UPDATE</Button>{' '}
                  </div>
                </form>
              )}
            />
          </div>
        </Modal>
      </div>
      <Modal isOpen={sucess} size="sm">
        <ModalBody style={{ color: 'green' }}>Created successfully!</ModalBody>
      </Modal>
      <Modal isOpen={editsucess} size="sm">
        <ModalBody style={{ color: 'green' }}>Updated successfully!</ModalBody>
      </Modal>
      <Modal isOpen={modalOpen} size="sm">
        <ModalBody style={{ backgroundColor: 'rgb(219 219 147)', color: 'white' }}>Your session has expired. Please sign in again.</ModalBody>
        <ModalFooter>
          <Button onClick={() => onLogout()} style={{ backgroundColor: '#09577C', color: 'white' }} type="button">
            LOGOUT
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={peropen} size="sm">
        <ModalBody style={{ color: 'red' }}>You have no acess to change it..!</ModalBody>
        <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: 20 }}>
          <Button onClick={() => permodalClose()} style={{ backgroundColor: 'red', color: 'white', border: 0 }}>Ok</Button>
        </div>
      </Modal>
    </>
  );
};

export default Banner;

